import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
// @ts-expect-error js file is not typed
import { getUser } from '../selectors/userSelectors';
import { useSelector } from 'react-redux';
import { ProfilePage } from 'academy-common-lib/features/profile/containers/Profile/ProfilePage';
import usageTracker from '../utils/UsageTracker';
import EditProfileContainer from 'academy-common-lib/features/profile/containers/EditProfile/EditProfileContainer';
import { useCallback } from 'react';
import { EDIT_PROFILE_URL_FRAGMENT, PROFILE_URL_FRAGMENT } from '../constants/Navigation';
import { jsx as _jsx } from "react/jsx-runtime";
const Profile = ({
  profileId
}) => {
  const user = useSelector(getUser);
  const trackPageView = useCallback(() => {
    usageTracker.track('pageView', {
      screen: 'profile',
      profileId
    });
  }, [profileId]);
  return /*#__PURE__*/_jsx(ProfilePage, {
    authedUser: {
      id: user.user_id
    },
    editPath: EDIT_PROFILE_URL_FRAGMENT,
    failureMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_LOAD_FAILURE"
    }),
    notFoundMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_NOT_FOUND_LOAD"
    }),
    profileId: profileId,
    showHeader: false,
    successMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_LOAD"
    }),
    trackPageView: trackPageView
  });
};
export const MyProfile = () => {
  const user = useSelector(getUser);
  return /*#__PURE__*/_jsx(Profile, {
    profileId: user.user_id.toString()
  });
};
export const UserProfile = () => {
  const {
    userId: userIdParam
  } = useParams();
  return /*#__PURE__*/_jsx(Profile, {
    profileId: userIdParam
  });
};
export const EditProfile = () => {
  const user = useSelector(getUser);
  const trackPageView = useCallback(() => {
    usageTracker.track('pageView', {
      screen: 'edit profile'
    });
  }, []);
  return /*#__PURE__*/_jsx(EditProfileContainer, {
    authedUser: {
      id: user.user_id
    },
    exitPath: PROFILE_URL_FRAGMENT,
    showHeader: false,
    successMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "EDIT_PROFILE_LOAD"
    }),
    trackInteraction: interaction => usageTracker.track('interaction', {
      action: interaction
    }),
    trackPageView: trackPageView
  });
};